export const VERSION = '4.5.1';
// export const BASE_URL = 'https://edunix-api.beetronix.com';
export const BASE_URL = 'https://api.almashriq.edunixsystem.com';
